import { render, staticRenderFns } from "./InviteDemoUserDialog.vue?vue&type=template&id=74f88248&"
import script from "./InviteDemoUserDialog.vue?vue&type=script&lang=js&"
export * from "./InviteDemoUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QForm,QCardSection,QSpace,QBtn,QInput,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QForm,QCardSection,QSpace,QBtn,QInput,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
